<template>
  <div v-for="(propVal, property) in value" :key="property">
    <div v-if="propVal !== null" class="row">
      <div class="col-3" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
        {{ trans(`models.${resourceType}.properties.${property}`) }}:
      </div>
      <div class="col-9">
        <plain-text :value="propVal"></plain-text>
      </div>
    </div>
  </div>
</template>

<script>
import PlainText from "@kanrisha/components/Elements/Display/PlainText";

export default {
  components: {
    PlainText,
  },
  props: {
    resourceType: { type: String, default: '' },
    value: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
